(() => {
  'use strict';
  function initialize() {
    document.querySelectorAll('.elite-price-payments[data-payment-pending]').forEach(group => {
      if (group.dataset.loadingBound) return;
      group.dataset.loadingBound = 'true';
      const panel = group.querySelector('[data-elite-product-apps]');
      const paypal = group.querySelector('elite-paypal-product-message');
      const expectsKlarna = !!group.querySelector('[data-klarna-initial]');
      const watchedRoots = new WeakSet();
      const shadowObservers = [];
      let pendingFrame = false;
      let attempts = 0;
      let released = false;
      function schedule() {
        if (pendingFrame) return;
        pendingFrame = true;
        requestAnimationFrame(update);
      }
      function update() {
        pendingFrame = false;
        if (!group.isConnected) return;
        const placement = panel?.querySelector('klarna-placement');
        const shadow = placement?.shadowRoot;
        if (shadow && !watchedRoots.has(shadow)) {
          watchedRoots.add(shadow);
          const observer = new MutationObserver(schedule);
          observer.observe(shadow, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
          shadowObservers.push(observer);
        }
        const klarnaReady = !expectsKlarna || !!(placement && !placement.hidden && shadow?.querySelector('[part~="osm-message"]')?.textContent.trim() && !shadow.querySelector('.loading'));
        const paypalReady = !paypal || paypal.hasAttribute('data-ready');
        if (group.hasAttribute('data-klarna-ready') !== klarnaReady) group.toggleAttribute('data-klarna-ready', klarnaReady);
        // Reveal both official offers in one paint. A blocked provider must not
        // indefinitely hold back the other provider's working popup.
        if (!released && klarnaReady && paypalReady) release();
      }
      function release() {
        released = true;
        group.removeAttribute('data-payment-pending');
      }
      const observer = new MutationObserver(schedule);
      observer.observe(group, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ready', 'data-preloaded', 'hidden'] });
      const timer = setInterval(() => {
        update();
        attempts++;
        if (attempts === 80 && !released) release();
        if (attempts >= 120 || !group.isConnected) {
          clearInterval(timer);
          if (!group.isConnected) {
            observer.disconnect();
            shadowObservers.forEach(item => item.disconnect());
          }
        }
      }, 100);
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
